import { FC } from 'react';
import { URLS } from '../../config/constants';
import useTracker from '../../hooks/useTracker';
import { MIXPANEL_EVENTS } from '../../mixpanel/config';
import CompanyLogo from '../../../Shared/components/CompanyLogo';
import { useUserAuth } from '~/components/Auth';
import { CompanyInfo } from '~/components/GlobalHeader/Shared/type';

interface CompanySettings {
  logoUrl?: string;
}

interface Company {
  companySettings?: CompanySettings;
  name?: string;
  logoUrl?: string;
}

const Logo: FC = () => {
  const track = useTracker();
  const auth = useUserAuth();
  const { company = {} as Company } = auth;
  const { companySettings, name, logoUrl } = company;
  const companyLogo = companySettings?.logoUrl || logoUrl; // TODO: Need to check with product as we are showing logo always, earlier we are not showing it

  return (
    <CompanyLogo
      company={{ companyLogo, name } as CompanyInfo}
      onLogoClick={() =>
        track(MIXPANEL_EVENTS.LEARNER_DASHBOARD_CLICKED, { from: MIXPANEL_EVENTS.HOME_ICON })
      }
      onCompanyNameClick={() =>
        track(MIXPANEL_EVENTS.LEARNER_DASHBOARD_CLICKED, { from: MIXPANEL_EVENTS.SITE_NAME })
      }
      redirectTo={URLS.LEARNER_HOME}
      isPageRefreshRequired={false}
      isMetaInfoRequired={false}
    />
  );
};

export default Logo;
